import AnimatedSpan from '../containers/animatedSpan/AnimatedSpan'
import Gantt from 'ibm-gantt-chart'
import 'ibm-gantt-chart/dist/ibm-gantt-chart.css'
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../hooks/useRequest'
import DefaultSelect from '../components/formElements/DefaultSelect'
import { getPermission } from '../utils/Auth'
import { projectTypes } from '../utils/Constants'
import Spinner from '../components/loader/Spinner'
import { Dialog } from 'primereact/dialog'
import icons from '../assets/icons'
import ApprovalContent from '../components/modalContent/ApprovalContent'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal, openApprovalModal } from '../redux/features/general/generalSlice'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import useWindowSize from '../hooks/useWindowSize'
import Button from '../components/formElements/Button'
import qs from 'qs'
import useToast from '../hooks/useToast'
import { InputNumber } from 'primereact/inputnumber'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Message } from 'primereact/message'
import { ToggleButton } from 'primereact/togglebutton'

Gantt.components.TreeTable.defaultClass += ' w-100'

const MasterPlan = () => {
	const [request] = useRequest()
	const { showToast } = useToast()
	const dispatch = useDispatch()
	const { general } = useSelector((state) => state)
	const { approvalModal } = general
	const { width } = useWindowSize()
	const [masterPlanLoading, setMasterPlanLoading] = useState(true)
	const [departments, setDepartments] = useState([])
	const [projectManagers, setProjectManagers] = useState([])
	const [projects, setProjects] = useState([])
	const [developers, setDevelopers] = useState([])
	const [skills, setSkills] = useState([])
	const [filterOptions, setFilterOptions] = useState({ departmentIds: [], projectManagerIds: [], showSla: false })
	const [masterPlan, setMasterPlan] = useState([])
	const [ganntTasks, setGanntTasks] = useState([])
	const [upsertModal, setUpsertModal] = useState({ open: false, masterPlan: {} })
	const [analysisModal, setAnalysisModal] = useState({ open: false, analysis: [] })
	const ganttRef = useRef()
	const gantt = useRef()
	const ganttConfig = {
		data: {
			resources: {
				activities: 'activities',
				name: 'name',
				id: 'id',
				parent: 'parent',
			},
			activities: {
				start: 'start',
				end: 'end',
				name: 'name',
			},
		},
		type: Gantt.type.SCHEDULE_CHART,
		table: {
			class: 'w-100',
			columns: [
				{
					name: 'rowNumbers',
					remove: true,
				},
				{
					name: 'hierarchy',
					title: ' ',
					renderer: {
						text: ' ',
						background: {
							getValue(data) {
								return data.departmentId
							},
							values: [null, 2, 3, 4, 5, 6, 7, 8, 10, 13],
							palette: [
								'#f7f5f5',
								'#d7e7d2',
								'#ffe699',
								'#C9DAF8',
								'#f8cbad',
								'#fff2cc',
								'#fff2cc',
								'#fce4d6',
								'#a4c2f4',
								'#ffffff',
							],
						},
						color: 'automatic',
					},
				},
			],
		},
		palette: ['#0D6EFD', '#FFC107', '#198754'],
		timeTable: {
			layout: {
				strategy: 'tile',
			},
			renderer: {
				background: {
					values: projectTypes.map((pt) => pt.type),
					getValue: 'projectType',
				},
				color: 'automatic',
				tooltipProperties: function (activity) {
					return [
						'Başlangıç',
						new Date(activity.start).toLocaleDateString('tr-TR', {
							year: 'numeric',
							month: 'long',
							day: 'numeric',
						}),
						'Bitiş',
						new Date(activity.end).toLocaleDateString('tr-TR', {
							year: 'numeric',
							month: 'long',
							day: 'numeric',
						}),
					]
				},
			},
			interactor: {
				click: {
					activityDoubleClicked: (e, selected) => {
						handleActivityClick(selected)
					},
					activityRightClicked: (e, selected) => {
						handleDelete(selected.id)
					},
				},
			},
		},
		divider: {
			pos: 225,
		},
		scrollableHorizonFactor: 1.05,
	}

	useEffect(() => {
		if (ganttRef.current && ganntTasks && ganntTasks.length > 0) {
			ganttConfig.data.resources.data = ganntTasks
			let date = new Date()
			let timeWindowStart = new Date(date.getFullYear(), date.getMonth() - 1, 1).getTime()
			let timeWindowEnd = new Date(date.getFullYear(), date.getMonth() + 6, 3).getTime()
			ganttConfig.data.timeWindow = {
				data: {
					start: timeWindowStart,
					end: timeWindowEnd,
				},
			}
			ganttRef.current.childNodes.forEach((c) => c.remove())
			Gantt.utils.setIntl({
				...Gantt.utils.getIntl(),
				locale: 'tr',
			})
			gantt.current = new Gantt(ganttRef.current, ganttConfig)
			gantt.current.initPromise.then(() => {
				const baseTimeTableDraw = gantt.current.timeTable.draw
				gantt.current.timeTable.draw = function (forceRedraw) {
					baseTimeTableDraw.call(this, forceRedraw)
					gantt.current.model.rows.forEach((row) => {
						let activities = row.getData().activities
						activities.forEach((activity) => {
							if (!activity.node) {
								return
							}
							let activityElement = activity.node
							let contentContainer = activityElement.querySelector('.content')
							let textElement = contentContainer.querySelector('.text-content')
							let textElementWidth = textElement.offsetWidth
							let scrollerRect = gantt.current.timeTable.scroller.getBoundingClientRect()
							let contentRect = contentContainer.getBoundingClientRect()

							if (textElementWidth > contentRect.width - 20) {
								textElement.style.marginLeft = '0px'
								return
							}

							if (contentRect.left < scrollerRect.left) {
								let marginLeft = scrollerRect.left - contentRect.left

								if (marginLeft >= contentRect.width - textElementWidth - 20) {
									marginLeft = contentRect.width - textElementWidth - 20
								}

								textElement.style.marginLeft = marginLeft + 'px'
							}
						})
					})
				}
				const baseLayoutFunc = gantt.current.timeTable.layout.layout
				gantt.current.timeTable.layout.layout = function (row) {
					baseLayoutFunc.call(this, row)
					activityTileLayout.call(this, row)
				}
			})
			gantt.current.on(Gantt.events.TIME_LINE_SCROLLED, function () {
				gantt.current.model.rows.forEach((row) => {
					let activities = row.getData().activities
					activities.forEach((activity) => {
						if (!activity.node) {
							return
						}
						let activityElement = activity.node
						let contentContainer = activityElement.querySelector('.content')
						let textElement = contentContainer.querySelector('.text-content')
						let textElementWidth = textElement.offsetWidth
						let scrollerRect = gantt.current.timeTable.scroller.getBoundingClientRect()
						let contentRect = contentContainer.getBoundingClientRect()

						if (textElementWidth > contentRect.width - 20) {
							textElement.style.marginLeft = '0px'
							return
						}

						if (contentRect.left < scrollerRect.left) {
							let marginLeft = scrollerRect.left - contentRect.left

							if (marginLeft >= contentRect.width - textElementWidth - 20) {
								marginLeft = contentRect.width - textElementWidth - 20
							}

							textElement.style.marginLeft = marginLeft + 'px'
						}
					})
				})
			})
			gantt.current.on(Gantt.events.TIME_LINE_INIT, function () {
				const firstSaturday = moment()
					.startOf('month')
					.add(6 - moment().startOf('month').day(), 'days')
					.toDate()
				gantt.current.timeLine.visTimeline.setOptions({
					showCurrentTime: true,
					timeAxis: { scale: 'week', step: 1 },
					hiddenDates: {
						start: firstSaturday,
						end: moment(firstSaturday).add(2, 'days').toDate(),
						repeat: 'weekly',
					},
					format: {
						minorLabels: {
							week: 'DD.MM.YYYY',
						},
					},
				})
				gantt.current.timeLine.zoom(1)
				const oldRepaintMinorText = gantt.current.timeLine.visTimeline.timeAxis._repaintMinorText
				gantt.current.timeLine.visTimeline.timeAxis._repaintMinorText = function (x, text, orientation, className) {
					if (!text) {
						let label = oldRepaintMinorText.call(this, x, text, orientation, className)
						let sibling = [...label.parentNode.childNodes].find((c) => c.className === label.className && c.style.width)
						if (sibling) {
							sibling.style.width = parseFloat(sibling.style.width) + parseFloat(label.style.width) + 'px'
						}
						return label
					}
					const date = moment(text, 'DD.MM.YYYY')
					if (!date.isValid()) {
						return oldRepaintMinorText.call(this, x, text, orientation, className)
					}
					const start = date.clone().startOf('week')
					const end = date.clone().add(4, 'days')
					text = start.format('DD.MM') + ' - ' + end.format('DD.MM')

					return oldRepaintMinorText.call(this, x, text, orientation, className)
				}
			})
		}

		return () => {
			ganttRef.current?.childNodes.forEach((c) => c.remove())
		}
	}, [ganntTasks])

	useEffect(() => {
		request('/Project/GetAllProjects', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setProjects(res.data.result.map((s) => ({ label: s.customerName + '/' + s.name, value: s.id })))
			}
		})

		request('/Developer/GetDepartments', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setDepartments(res.data.result.map((s) => ({ label: s.name, value: s.id })))
			}
		})

		request('/Developer/GetDeveloperSkills', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setSkills(res.data.result.map((s) => ({ label: s.name, value: s.id })))
			}
		})

		request('/Developer/GetAllDevelopers', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setDevelopers(
					res.data.result
						.sort((a, b) => a.fullName.localeCompare(b.fullName))
						.map((s) => ({
							label: s.fullName,
							value: s.id,
						}))
				)
			}
		})

		request('/Account/GetAllUsers', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setProjectManagers(
					res.data.result
						.filter((u) => u.roles.find((r) => r.normalizedName === 'PROJECTMANAGER'))
						.map((s) => ({
							label: s.firstName + ' ' + s.lastName,
							value: s.id,
						}))
						.sort((a, b) => a.label.localeCompare(b.label))
				)
			}
		})
	}, [])

	useEffect(() => {
		if (!masterPlanLoading) {
			return
		}

		request('/MasterPlan/GetAllMasterPlan', {
			method: 'GET',
			params: filterOptions,
			paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
		}).then((res) => {
			if (res.data.ok) {
				setMasterPlan(res.data.result)
			}
			setMasterPlanLoading(false)
		})
	}, [filterOptions, masterPlanLoading])

	useEffect(() => {
		const resources = []
		masterPlan.forEach((mp) => {
			const projectId = mp.developerId || 'Plansız'
			const project = {
				id: projectId,
				name: mp.developerFullName || 'Plansız',
				departmentId: mp.departmentId,
				activities:
					mp.projects?.map((t, i) => {
						return {
							id: t.id,
							name: t.projectId ? [t.projectCustomerName, t.projectName].join(' / ') : t.customProject,
							start: new Date(t.startDate).getTime(),
							end: new Date(t.endDate).getTime(),
							projectType: t.projectType,
							getObjectType: () => Gantt.ObjectTypes.Activity,
							order: i,
						}
					}) || [],
			}
			resources.push(project)
		})

		setGanntTasks(resources)
	}, [masterPlan])

	useEffect(() => {
		setMasterPlanLoading(true)
	}, [filterOptions])

	const activityTileLayout = function (row) {
		let rowHeight = row.tableRowHeight

		let { topMargin } = this
		let { bottomMargin } = this
		let subRowHeight = rowHeight - topMargin - bottomMargin - 1
		if (subRowHeight <= 0) {
			subRowHeight = 1
			const availMargin = rowHeight - subRowHeight
			topMargin = (availMargin * topMargin) / (topMargin + bottomMargin)
			bottomMargin = availMargin - topMargin
		}

		row.activities.sort((a, b) => a.order - b.order)

		// Finally, assign graphics to subrows, increasing the number of subrows as
		// necessary so that the graphics do not overlap.
		const subRows = this.setTaskSubRows(row)

		// For constant row height, we subdivide the row's current height into the required
		// number of subrows. For constant subrow height, we expand the row to accommodate the
		// required number of subrows
		let subRowMargin = this.subRowPadding
		if (this.constantRowHeight) {
			if (subRowMargin * (subRows.length - 1) >= subRowHeight) {
				subRowMargin = subRowHeight / (subRows.length - 1)
			}
			subRowHeight = (subRowHeight - (subRows.length - 1) * subRowMargin) / subRows.length
		} else {
			rowHeight = topMargin + bottomMargin + subRows.length * subRowHeight + (subRows.length - 1) * subRowMargin
			// Set the row height so that each subrow has the chart's global row
			// height.
			row.setRowHeight(Math.round(rowHeight))
		}

		// Set the vertical bounds of the activities in each subrow.
		let top = topMargin
		let subRowTasks
		let task
		for (var i = 0, iTask; i < subRows.length; i++) {
			subRowTasks = subRows[i]
			for (iTask = 0; iTask < subRowTasks.length; iTask++) {
				task = subRowTasks[iTask]
				task.node.style.top = `${top}px`
				task.node.style.height = `${subRowHeight}px`
			}
			top += subRowHeight + subRowMargin
		}
	}

	const handleFilterOptions = (e, name) => {
		setFilterOptions((prev) => ({
			...prev,
			[name || e.target.name]: e && e.target ? e.target.value : e,
		}))
	}

	const handleFormChange = (e, name) => {
		setUpsertModal((prev) => ({
			...prev,
			masterPlan: { ...prev.masterPlan, [name || e.target.name]: e && e.target ? e.target.value : e },
		}))
	}

	const handleProjectChange = (e) => {
		let isProjectId = Number.isInteger(e)

		setUpsertModal((prev) => ({
			...prev,
			masterPlan: {
				...prev.masterPlan,
				projectId: isProjectId ? e : null,
				customProject: isProjectId ? null : e,
			},
		}))
	}

	const handleSkillsChange = (e) => {
		let skills =
			e?.map((t) => ({
				id: upsertModal.masterPlan.masterPlanSkills?.find((mt) => mt.skillId === t.value)?.id,
				skillId: t.value,
			})) || []

		setUpsertModal((prev) => ({
			...prev,
			masterPlan: {
				...prev.masterPlan,
				masterPlanSkills: skills,
			},
		}))
	}

	const validateUpsertModal = () => {
		if (!upsertModal.masterPlan.projectId && !upsertModal.masterPlan.customProject) {
			showToast('Proje alanı boş bırakılamaz', 'error')
			return false
		}

		if (!upsertModal.masterPlan.startDate) {
			showToast('Başlangıç tarihi alanı boş bırakılamaz', 'error')
			return false
		}

		if (!upsertModal.masterPlan.endDate) {
			showToast('Bitiş tarihi alanı boş bırakılamaz', 'error')
			return false
		}

		if (upsertModal.masterPlan.startDate > upsertModal.masterPlan.endDate) {
			showToast('Başlangıç tarihi bitiş tarihinden büyük olamaz', 'error')
			return false
		}

		if (!upsertModal.masterPlan.projectType) {
			showToast('Proje tipi alanı boş bırakılamaz', 'error')
			return false
		}

		return true
	}

	const handleUpsertSubmit = () => {
		if (!validateUpsertModal()) {
			return
		}

		let data = {
			...upsertModal.masterPlan,
			startDate: moment(upsertModal.masterPlan.startDate).toISOString(true),
			endDate: moment(upsertModal.masterPlan.endDate).toISOString(true),
		}

		request('/MasterPlan/UpsertMasterPlan', { method: 'PUT', data: data }).then((res) => {
			if (res.data.ok) {
				setMasterPlanLoading(true)
				handleCloseUpsertModal()
			}
		})
	}

	const handleCloseUpsertModal = () => {
		setUpsertModal({ open: false, masterPlan: {} })
	}

	const handleApprovalModalApproved = () => {
		if (approvalModal.requestType === 'delete') {
			deleteMasterPlan(approvalModal.id).then(() => {
				handleCloseApprovalModal()
				handleCloseUpsertModal()
			})
		} else if (approvalModal.requestType === 'update') {
			updateMasterPlanDate(approvalModal.task).then(() => {
				handleCloseApprovalModal()
			})
		}
	}

	const handleCloseApprovalModal = () => {
		dispatch(closeApprovalModal())
	}

	const deleteMasterPlan = (id) => {
		return new Promise((resolve, reject) => {
			request('/MasterPlan/DeleteMasterPlan', {
				method: 'DELETE',
				data: {
					id: id,
				},
			}).then((res) => {
				if (res.data.ok) {
					setMasterPlanLoading(true)
					resolve()
				} else {
					reject()
				}
			})
		})
	}

	const updateMasterPlanDate = (task) => {
		return new Promise((resolve, reject) => {
			request('/MasterPlan/UpdateMasterPlanDate', {
				method: 'POST',
				data: {
					id: task.id,
					startDate: task.start,
					endDate: task.end,
				},
			}).then((res) => {
				if (res.data.ok) {
					setMasterPlanLoading(true)
					resolve()
				} else {
					reject()
				}
			})
		})
	}

	// const debounce = (func, delay) => {
	// 	let timeoutId
	// 	return function (...args) {
	// 		clearTimeout(timeoutId)
	// 		timeoutId = setTimeout(() => func(...args), delay)
	// 	}
	// }

	// const handleTaskChange = debounce((task) => {
	// 	if (task.type !== 'task') {
	// 		return
	// 	}
	//
	// 	dispatch(
	// 		openApprovalModal({
	// 			open: true,
	// 			content: 'Plan tarihleri değiştirilecektir. Onaylıyor musunuz?',
	// 			requestType: 'update',
	// 			task: task,
	// 		})
	// 	)
	// }, 300)

	const handleDelete = (id) => {
		dispatch(
			openApprovalModal({
				open: true,
				content: 'Plan silinecektir. Onaylıyor musunuz?',
				requestType: 'delete',
				id: id,
			})
		)
	}

	const handleDeleteFromUpsertModal = () => {
		handleDelete(upsertModal.masterPlan.id)
	}

	const handleActivityClick = (activity) => {
		request('/MasterPlan/GetMasterPlanById', { method: 'GET', params: { id: activity.id } }).then((res) => {
			if (res.data.ok) {
				setUpsertModal({ open: true, masterPlan: res.data.result })
			}
		})
	}

	const handleAnalysisModalOpen = () => {
		request('/MasterPlan/GetMasterPlanAnalysis', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setAnalysisModal({ open: true, analysis: res.data.result || [] })
			}
		})
	}

	const handleAnalysisModalClose = () => {
		setAnalysisModal({ open: false, analysis: [] })
	}

	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			<div className='card'>
				<div className='d-flex justify-content-between gap-3'>
					<div className='row flex-1'>
						<div className='col-md-3'>
							<DefaultSelect
								isMulti={true}
								isClearable
								name='departmentIds'
								placeholder='Departmanlar'
								value={departments.filter((d) => filterOptions.departmentIds?.includes(d.value))}
								selectOptions={departments}
								handleChange={(e) =>
									handleFilterOptions(
										e.map((d) => d.value),
										'departmentIds'
									)
								}
							/>
						</div>
						<div className='col-md-3'>
							<DefaultSelect
								isMulti={true}
								isClearable
								name='projectManagerIds'
								placeholder='Proje Yöneticileri'
								value={projectManagers.filter((d) => filterOptions.projectManagerIds?.includes(d.value))}
								selectOptions={projectManagers}
								handleChange={(e) =>
									handleFilterOptions(
										e.map((d) => d.value),
										'projectManagerIds'
									)
								}
							/>
						</div>
						<div className='col-md-3'>
							<ToggleButton
								onLabel='SLA Projeleri Gizle'
								offLabel='SLA Projeleri Göster'
								onIcon='pi pi-eye'
								offIcon='pi pi-eye-slash'
								style={{ fontWeight: 'normal' }}
								checked={filterOptions.showSla}
								onChange={(e) => handleFilterOptions(e.value, 'showSla')}
							/>
						</div>
					</div>

					<div className='filters-right gap-2'>
						<Button
							handleClick={() => handleAnalysisModalOpen()}
							className='btn-primary'
							title={width <= 936 ? '' : 'Analiz'}
							icon={<icons.report2 />}
						/>
						{getPermission('MasterPlan.update') && (
							<Button
								handleClick={() => setUpsertModal({ open: true, masterPlan: {} })}
								className='btn-success'
								title={width <= 936 ? '' : 'Plan Ekle'}
								icon={<icons.plus />}
							/>
						)}
					</div>
				</div>
			</div>

			<div className='card' style={ganntTasks && ganntTasks.length > 0 ? { height: '100%' } : {}}>
				{masterPlanLoading && (
					<div className='d-flex w-100 justify-content-center align-items-center'>
						<Spinner size={3} />
					</div>
				)}
				{ganntTasks && ganntTasks.length > 0 ? (
					<div ref={ganttRef} style={{ height: '100%' }} />
				) : (
					!masterPlanLoading && <div className='text-sm text-semi-bold'>Gösterilecek Veri Bulunmuyor</div>
				)}
			</div>

			{upsertModal.open && (
				<Dialog
					header='Plan Ekle'
					style={{ height: '', width: '700px', maxWidth: '100%' }}
					draggable={false}
					visible={upsertModal.open}
					onHide={handleCloseUpsertModal}
				>
					<div className='w-100 d-flex flex-column gap-3'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Kişi</label>
									<DefaultSelect
										isClearable
										isSearchable
										placeholder='Kişi'
										name='developerId'
										value={developers.find((d) => d.value === upsertModal.masterPlan.developerId)}
										selectOptions={developers}
										handleChange={(e) => handleFormChange(e?.value, 'developerId')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Proje</label>
									<Dropdown
										value={upsertModal.masterPlan.projectId || upsertModal.masterPlan.customProject}
										onChange={(e) => handleProjectChange(e?.value)}
										options={projects}
										optionLabel='label'
										optionValue='value'
										filter
										editable
										showFilterClear
										className={'w-100'}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='form-control-label'>Başlangıç Tarihi</label>
									<Calendar
										className='w-100'
										dateFormat='dd/mm/yy'
										value={upsertModal.masterPlan.startDate && new Date(upsertModal.masterPlan.startDate)}
										name='startDate'
										onChange={handleFormChange}
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='form-control-label'>Bitiş Tarihi</label>
									<Calendar
										className='w-100'
										dateFormat='dd/mm/yy'
										value={upsertModal.masterPlan.endDate && new Date(upsertModal.masterPlan.endDate)}
										name='endDate'
										onChange={handleFormChange}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Plan Proje Tipi</label>
									<DefaultSelect
										value={projectTypes
											.map((pt) => ({
												label: pt.type.toUpperCase(),
												value: pt.type,
											}))
											.find((pt) => pt.value === upsertModal.masterPlan.projectType)}
										name='projectType'
										handleChange={(e) => handleFormChange(e.value, 'projectType')}
										selectOptions={projectTypes.map((pt) => ({
											label: pt.type.toUpperCase(),
											value: pt.type,
										}))}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Kullanılacak Yetkinlikler</label>
									<DefaultSelect
										isMulti
										value={upsertModal.masterPlan.masterPlanSkills?.map((t) =>
											skills.find((tt) => tt.value === t.skillId)
										)}
										handleChange={(e) => handleSkillsChange(e)}
										name='masterPlanSkills'
										selectOptions={skills}
									/>
									<small className='block text-left'>
										Yetkinlikler, doluluk oranı analizinde kullanılır. Boş bırakılırsa geliştiricide tanımlı tüm
										yetkinlikler kullanılır.
									</small>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className='form-control-label'>Analiz Katsayısı</label>
									<InputNumber
										className='w-100'
										value={upsertModal.masterPlan.analysisFactor}
										mode='decimal'
										showButtons
										step={0.5}
										name='analysisFactor'
										onChange={(e) => handleFormChange(e.value, 'analysisFactor')}
									/>
									<small className='block text-left'>
										Analiz katsayısı, doluluk oranı analizinde kullanılır. Örneğin 0.5 değerinin analize etkisi yarım
										gündür. Boş bırakılırsa tam gün (1) olarak hesaplanır.
									</small>
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-6 d-flex gap-3'>
								<Button className='btn-danger' title='Sil' handleClick={handleDeleteFromUpsertModal} />
							</div>
							<div className='col-md-6 d-flex justify-content-end gap-3'>
								<Button className='btn-danger-outline' title='Vazgeç' handleClick={handleCloseUpsertModal} />
								<Button className='btn-success' title='Kaydet' handleClick={handleUpsertSubmit} />
							</div>
						</div>
					</div>
				</Dialog>
			)}

			<Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
				<ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleApprovalModalApproved} />
			</Dialog>

			{analysisModal.open && (
				<Dialog
					header='Analiz'
					style={{ height: '', width: '700px', maxWidth: '100%' }}
					draggable={false}
					visible={analysisModal.open}
					onHide={handleAnalysisModalClose}
				>
					<div className='w-100 d-flex flex-column gap-3'>
						<Message
							className='justify-content-start'
							severity='info'
							text='Analiz bulunduğumuz aydan itibaren 6 ayı kapsamaktadır.'
						/>

						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
									stripedRows
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									editMode='row'
									dataKey='skillId'
									value={analysisModal.analysis}
									sortField='planRate'
									sortOrder={1}
								>
									<Column
										sortable
										className='text-semi-bold text-sm col-md-6'
										headerClassName='text-bold bg-primary text-default'
										field='skillName'
										style={{ width: '50%' }}
										header='Yetkinlik'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='planRate'
										style={{ width: 'auto' }}
										header='Doluluk Oranı'
										body={(rowData) => <span>{(rowData?.planRate * 100).toFixed(2)}%</span>}
									/>
								</DataTable>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-12 d-flex justify-content-end gap-3'>
								<Button className='btn-danger-outline' title='Kapat' handleClick={handleAnalysisModalClose} />
							</div>
						</div>
					</div>
				</Dialog>
			)}
		</AnimatedSpan>
	)
}

export default MasterPlan
